import React from "react"

const CheckIcon: React.FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3617 6.07449C15.2859 5.99808 15.1957 5.93743 15.0964 5.89604C14.997 5.85465 14.8905 5.83334 14.7829 5.83334C14.6752 5.83334 14.5687 5.85465 14.4693 5.89604C14.37 5.93743 14.2798 5.99808 14.204 6.07449L8.13027 12.1564L5.57848 9.59645C5.49979 9.52043 5.4069 9.46066 5.30511 9.42055C5.20332 9.38043 5.09462 9.36076 4.98523 9.36265C4.87584 9.36454 4.76789 9.38796 4.66755 9.43158C4.56721 9.47519 4.47644 9.53814 4.40042 9.61683C4.32441 9.69552 4.26464 9.78841 4.22452 9.8902C4.18441 9.99199 4.16474 10.1007 4.16663 10.2101C4.16852 10.3195 4.19194 10.4274 4.23555 10.5278C4.27916 10.6281 4.34211 10.7189 4.4208 10.7949L7.55143 13.9255C7.62722 14.0019 7.71739 14.0626 7.81674 14.104C7.91609 14.1454 8.02265 14.1667 8.13027 14.1667C8.2379 14.1667 8.34446 14.1454 8.4438 14.104C8.54315 14.0626 8.63332 14.0019 8.70911 13.9255L15.3617 7.27293C15.4444 7.19659 15.5105 7.10393 15.5557 7.0008C15.6008 6.89767 15.6242 6.7863 15.6242 6.67371C15.6242 6.56112 15.6008 6.44975 15.5557 6.34662C15.5105 6.24349 15.4444 6.15083 15.3617 6.07449Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default CheckIcon
